import HttpHandler from 'app/reusable/HttpHandler'
import history from 'history.js'
import * as types from './types'
import { isExternalUrl } from './constants'

/**
 * Loads the campaigns published for the logged user
 * (GET internal-campaigns/api/campaigns/). Every consumer (top-bar badge,
 * popup, Novidades page) calls this on mount; it only hits the API once per
 * session — or again after a failed attempt.
 */
export const fetchInternalCampaigns =
  ({ force = false } = {}) =>
  (dispatch, getState) => {
    const { status } = getState().internalCampaigns
    if (!force && (status === 'loading' || status === 'loaded')) return

    dispatch({ type: types.FETCH_INTERNAL_CAMPAIGNS })
    return HttpHandler.listInternalCampaigns()
      .then(({ data }) =>
        dispatch({
          type: types.FETCH_INTERNAL_CAMPAIGNS_SUCCESS,
          payload: Array.isArray(data) ? data : [],
        })
      )
      .catch((error) =>
        dispatch({ type: types.FETCH_INTERNAL_CAMPAIGNS_ERROR, payload: error })
      )
  }

// Optimistic: the campaign stops counting as new right away; a failed POST
// only means it shows up as new again on the next session.
const markSeen = (id) => ({
  type: types.MARK_INTERNAL_CAMPAIGN_SEEN,
  payload: id,
})

export const dismissInternalCampaign = (id) => (dispatch) => {
  dispatch(markSeen(id))
  return HttpHandler.dismissInternalCampaign(id).catch(() => {})
}

export const markAllInternalCampaignsSeen = () => (dispatch, getState) => {
  const newCampaigns = getState().internalCampaigns.items.filter(
    (campaign) => campaign.is_new
  )
  return Promise.all(
    newCampaigns.map((campaign) =>
      dispatch(dismissInternalCampaign(campaign.id))
    )
  )
}

/**
 * Records the CTA click (which also dismisses the campaign) and follows it:
 * app paths navigate in place, http(s) URLs open in a new tab.
 */
export const followInternalCampaignCta = (campaign) => (dispatch) => {
  dispatch(markSeen(campaign.id))
  HttpHandler.clickInternalCampaignCta(campaign.id).catch(() => {})

  if (isExternalUrl(campaign.cta_url))
    window.open(campaign.cta_url, '_blank', 'noopener,noreferrer')
  else history.push(campaign.cta_url)
}
